module.exports = __webpack_public_path__ + "img/339da7f.svg";